import React from 'react';
import './subscriptionDurationForm.css';
import { useSelector, useDispatch } from "react-redux";
import { subscriptionDurationFormAction, typeOpenSettingsFormAction } from "../../redux/rootReducer";
import { updateSubscriptionDurationSagaAction } from "../../redux/sagaActions";

const SubscriptionDurationForm = () => {
    const dispatch = useDispatch();
    const establishmentList = useSelector(state => state.establishmentList);
    const subscription_duration_form = useSelector(state => state.subscription_duration_form);

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <i className="form__close" onClick={ () => dispatch(typeOpenSettingsFormAction('')) } />
                        <div className="form__title">{
                            subscription_duration_form.id
                                ? 'Срок действия'
                                : 'Новый срок действия'
                        }</div>
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Название срока действия</div>
                        <input type="text" className="input" value={ subscription_duration_form.name }
                            onInput={ event => dispatch(subscriptionDurationFormAction({
                                ...subscription_duration_form,
                                name: event.target.value
                            })) }
                        />
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Размер срока действия</div>
                        <div className="table">
                            <div className="table__row table__row--header duration__row">
                                <div className="table__cell">День</div>
                                <div className="table__cell">Месяц</div>
                                <div className="table__cell">Год</div>
                            </div>
                            <div className="table__row duration__row">
                                <div className="table__cell">
                                    <input
                                        type="number"
                                        className="input input--cell"
                                        value={ subscription_duration_form.interval.day }
                                        onInput={ event => dispatch(subscriptionDurationFormAction({
                                            ...subscription_duration_form,
                                            interval: {
                                                ...subscription_duration_form.interval,
                                                day: event.target.value
                                            }
                                        })) }/>
                                </div>
                                <div className="table__cell">
                                    <input
                                        type="number"
                                        className="input input--cell"
                                        value={ subscription_duration_form.interval.month }
                                        onInput={ event => dispatch(subscriptionDurationFormAction({
                                            ...subscription_duration_form,
                                            interval: {
                                                ...subscription_duration_form.interval,
                                                month: event.target.value
                                            }
                                        })) }/>
                                </div>
                                <div className="table__cell">
                                    <input
                                        type="number"
                                        className="input input--cell"
                                        value={ subscription_duration_form.interval.year }
                                        onInput={ event => dispatch(subscriptionDurationFormAction({
                                            ...subscription_duration_form,
                                            interval: {
                                                ...subscription_duration_form.interval,
                                                year: event.target.value
                                            }
                                        })) }/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="form__field">
                        <div className="input__caption">Заморозка (кол-во дней)</div>
                        <input type="number"
                             className="input"
                             value={ subscription_duration_form.freeze_days }
                               onInput={ event => dispatch(subscriptionDurationFormAction({
                                   ...subscription_duration_form,
                                   freeze_days: event.target.value
                               }))}
                        />
                    </div>
                    <div className="form__field">
                        <div className="input__caption">Число заморозок</div>
                        <input type="number"
                               className="input"
                               value={ subscription_duration_form.freeze_times }
                               onInput={ event => dispatch(subscriptionDurationFormAction({
                                   ...subscription_duration_form,
                                   freeze_times: event.target.value
                               }))}
                        />
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required" style={{ marginBottom: '10px' }}>Для каких заведений</div>
                        {
                            establishmentList.map(elem => {
                                return (
                                    <div style={{ marginBottom: '10px' }} key={ elem.id }>
                                        <div className="checkbox__wrapper" onClick={ () => {
                                            // Старый массив с заведениями
                                            let est = [...subscription_duration_form.establishments];
                                            // Ищем индекс выбранного элемента
                                            let findIndex = est.findIndex(el => el === elem.id);
                                            // Если в массиве есть выбранный элемент, удаляем его
                                            if (findIndex + 1) {
                                                est.splice(findIndex, 1);
                                            }
                                            else {
                                                est.push(elem.id);
                                            }

                                            dispatch(subscriptionDurationFormAction({
                                                ...subscription_duration_form,
                                                establishments: est
                                            }));

                                        } }>
                                            <div className={ `checkbox ${ subscription_duration_form.establishments.includes(elem.id) ? 'checkbox--active' : '' }` }/>
                                            <div className="checkbox__caption">{ elem.name }</div>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                    <div className="form__field">
                        <div className="button"
                            onClick={ () => {
                                dispatch(updateSubscriptionDurationSagaAction({
                                    id: subscription_duration_form.id,
                                    name: subscription_duration_form.name,
                                    establishments: JSON.stringify(subscription_duration_form.establishments),
                                    interval: JSON.stringify(subscription_duration_form.interval),
                                    freeze_days: subscription_duration_form.freeze_days,
                                    freeze_times: subscription_duration_form.freeze_times
                                }));
                            } }
                        >
                            Сохранить
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SubscriptionDurationForm;